// extracted by mini-css-extract-plugin
module.exports = {"container":"DealsBanner-module__container___u+hX+","centerContainer":"DealsBanner-module__centerContainer___M3-uo"};